<fieldset bsMigration [bs3Class]="['panel-primary']" class="panel">
  <div bsMigration [bs4Class]="['bg-primary', 'text-light']" class="panel-heading">Primary {{ SchoolType }} School
    Information</div>
  <div bsMigration class="panel-body">
    <p *ngIf="PreviousRecord && !training.School.Name">
      <button type="button" class="btn btn-info" (click)="CopyPrevious(PreviousRecord);">Copy School information from
        {{ AsnInfomation[PreviousRecord.Association].label }}</button>
    </p>
    <div [bs4Class]="['mb-2']" class="form-group required" [class.has-error]="StateHasError | async">
      <label for="input-school-state">School State/Province</label>
      <select id="input-school-state" [class.is-invalid]="StateHasError | async" [bs3Class]="['form-control']"
        [bs4Class]="['form-select']" [(ngModel)]="State" (change)="StateOnChange($event);" required [disabled]="IsStudentPortal">
        <optgroup label="United States">
          <option *ngFor="let state of settings.states" [ngValue]="state.sta_code">{{ state.sta_name }}
          </option>
        </optgroup>
        <optgroup label="International">
          <option [ngValue]="ForeignLoc">{{ ForeignOrg.org_name }}</option>
        </optgroup>
      </select>
    </div>
    <ng-container [formGroup]="parentGroup">
      <ng-container formGroupName="School">
        <p *ngIf="Level == 'Student' && HasStudentPortals" [bs4Class]="['my-0']" class="help-block alert alert-warning">Your school should have provided you with a custom signup URL. Please use that URL so your account is correctly configured.</p>
        <div [bs4Class]="['mb-2']" *ngIf="group.value.State" class="form-group required" [class.has-error]="NameHasError | async">
          <label for="input-school-name">School Name</label>
          <div class="input-group">
            <span bsMigration class="input-group-addon">
              <fa-icon [icon]="faMagnifyingGlass"></fa-icon>
            </span>
            <input type="text" [class.is-invalid]="NameHasError | async" class="form-control" id="input-school-name"
              formControlName="Name" autocomplete="off" placeholder="school name" required
              [readonly]="State === ForeignLoc || IsStudentPortal" [typeaheadWaitMs]="300" [typeaheadAsync]="true" [typeahead]="Schools$"
              [typeaheadItemTemplate]="item" typeaheadOptionField="org_name"
              (typeaheadOnSelect)="SchoolOnSelect($event)">
          </div>
          <p [bs4Class]="['my-0']" class="help-block">Start typing a few letters to search our database. If not found, just enter the full
            school name and not acronym.</p>
        </div>
        <ng-container *ngIf="group.value.Name != 'Closed School' && State !== ForeignLoc">
          <div class="row" [hidden]="!group.value.State">
            <div bsMigration class="form-group required col-xs-6 col-sm-4" [class.has-error]="CityHasError | async">
              <label for="input-school-city">City</label>
              <input type="text" [class.is-invalid]="CityHasError | async" class="form-control" id="input-school-city"
                formControlName="City" placeholder="city" required>
            </div>
            <div bsMigration class="form-group required col-xs-3 col-md-4">
              <label>State</label>
              <ng-container bsMigrationPicker [bs3]="stateBs3" [bs4]="stateBs4">
                <ng-template #stateBs4>
                  <input type="text" readonly class="form-control-plaintext" [value]="group.value.State">
                </ng-template>
                <ng-template #stateBs3>
                  <p class="form-control-static">{{ group.value.State }}</p>
                </ng-template>
              </ng-container>
            </div>
            <div bsMigration [bs4Class]="['mb-2']" class="form-group col-xs-3">
              <label for="input-school-zip">Zip</label>
              <input type="text" class="form-control" id="input-school-zip" formControlName="Zip" placeholder="#####">
            </div>
          </div>
          <div [bs4Class]="['mb-2']" class="form-group" [hidden]="!group.value.State">
            <label for="input-school-phone">School Phone</label>
            <input type="tel" class="form-control" id="input-school-phone" formControlName="Phone"
              placeholder="###-###-####">
          </div>
          <app-school-instructor-referral *ngIf="IsUpgrade && NoHowHeard && IsInstructorReferral && group.value.Key"
            [School]="group.value.Key" [parentGroup]="group" class="form-group required"
            [ngClass]="{ 'has-error' :  InstructorHasError }">
          </app-school-instructor-referral>
        </ng-container>
      </ng-container>
      <div class="row">
        <div bsMigration class="form-group required col-xs-6" [hidden]="!group.value.State"
          [class.has-error]="CourseLengthHasError | async">
          <label for="input-courselength">Length of {{ Level === 'Professional' ? 'Training' : 'Course' }}</label>
          <div class="input-group">
            <input type="number" [class.is-invalid]="CourseLengthHasError | async" class="form-control"
              id="input-courselength" formControlName="CourseLength" placeholder="###" required>
            <span bsMigration class="input-group-addon">hours</span>
          </div>
        </div>
        <div bsMigration [bs4Class]="['mb-2']" class="form-group required col-xs-6" [hidden]="!group.value.State"
          [class.has-error]="GraduationDateHasError | async">
          <label for="input-graduationdate">Graduation Date</label>
          <input type="text" [class.is-invalid]="GraduationDateHasError | async" class="form-control"
            id="input-graduationdate" placeholder="mm/dd/yyyy" formControlName="GraduationDate" required bsDatepicker>
        </div>
      </div>
      <alert type="danger" *ngIf="CourseLengthError">
        <p>Our <strong>{{ Selection.Type.mbt_code }}</strong> membership levels require at least
          {{ Selection.Type.mbt_code == 'Certified' ? 500 : 100 }} hours of qualifying training.</p>
        <p *ngIf="Selection.Type.mbt_code === 'Certified'">If you have less than 500 hours, please consider our
          Professional level that only requires you meet your state's requirements.</p>
        <p><button bsMigration type="button" class="btn btn-default" [routerLink]="['/signup', 'selection']">Start
            Over</button></p>
      </alert>
      <alert type="warning" *ngIf="GradDateWarning">
        <p>Graduation Date should be in the past for this level of membership, as your professional liability insurance
          is typically not valid until you've completed your training and obtained your state licensing/credentialing.
        </p>
        <p>Please contact us {{ settings.site_phone }} at or email <a [href]="'mailto:' + settings.site_mail">{{
            settings.site_mail }}</a> for more information.</p>
      </alert>
      <div class="form-group required" [hidden]="!group.value.State" [class.has-error]="NameAttendedHasError | async">
        <label for="input-nameattended">Name attended school under</label>
        <input type="text" [class.is-invalid]="NameAttendedHasError | async" class="form-control"
          id="input-nameattended" formControlName="NameAttended" placeholder="your name" required>
      </div>
    </ng-container>
    <ng-container *ngIf="NeedTranscript">
      <p>You may fax or email your transcripts to us at {{ settings.site_phone }} or <a
          [href]="'mailto:' + settings.site_mail">{{
          settings.site_mail }}</a>. Alternately, we will call your school to verify training.</p>
      <p>Please note: Some schools do not verify training over the phone, in which case we will contact you directly for
        verification.</p>
      <p class="text-warning">Licensed professionals do not need to provide transcripts.</p>
    </ng-container>
  </div>
</fieldset>

<ng-template #item let-model="item" let-index="index">
  <strong>{{ model.org_name }}</strong> - {{ model.adr_line1 }}, {{ model.adr_city }}
</ng-template>